export default __webpack_public_path__ + "static/CrossedArms-48fc29ab1e7874ed6a68b880439d7a66.svg";